export const GROUP_BY_OPTIONS = {
  ar: [
    { value: "", label: "بدون تجميع" },
    { value: "Month", label: "شهر" },
    { value: "Year", label: "سنة" },
  ],
  en: [
    { value: "", label: "No Grouping" },
    { value: "Month", label: "Month" },
    { value: "Year", label: "Year" },
  ],
};
